import { Component, OnInit } from '@angular/core';
import { SpecialtiesService } from '../specialties/specialties.service';
import { InsurancesService } from '../insurances/insurances.service';
import { Observable } from 'rxjs';
import { FacilitiesService } from '../facilities/facilities.service';
import { ContactsService } from '../contacts/contacts.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  contacts$: Observable<any>
  specialties$: Observable<any[]>
  insurances$: Observable<any[]>

  constructor(
    private cs: ContactsService,
    private fs: FacilitiesService,
    private ss: SpecialtiesService,
    private is: InsurancesService,
  ) {
    
  }

  ngOnInit() {

  }
}
